import { notification } from 'antd'
import { removeUserAuthCookie } from '@utils/helpers/authHelper'
import isEmpty from 'lodash/isEmpty'
import Axios, { AxiosError, AxiosRequestConfig } from 'axios'
import { COOKIE_KEYS, getCookie } from '@features/General'
import { awsConfig } from 'awsConfig'
const TIMEOUT = 60000

// if you want another config, create one!!
const DEFAULTCONFIG: AxiosRequestConfig = {
    baseURL: awsConfig.BASEURL,
    timeout: TIMEOUT
}

const NO_NEED_AUTH_URLS = ['auth/login']

const request = Axios.create(DEFAULTCONFIG)

request.interceptors.request.use(config => {
    const token = getCookie(COOKIE_KEYS.ALA_TOKEN)
    const userRole = getCookie(COOKIE_KEYS.ALA_USER_TYPE)
    const event = getCookie(COOKIE_KEYS.ALA_EVENT)

    if (!NO_NEED_AUTH_URLS.includes(config.url) && !isEmpty(token)) {
        config.headers['Authorization'] = `Bearer ${token}`
        if (userRole && event) config.headers['event-id'] = event
    }
    return config
})

let errorCount = 0

request.interceptors.response.use(
    function (response) {
        return response.data
    },
    function (error: AxiosError) {
        // This array includes some endpoints that must not logout the user when call them
        // const whiteListURLs = ['/companies/stats/onboarding-status/']
        // const isAllowedURL = whiteListURLs.reduce((prev, item) => prev || error.config.url.includes(item), false)
        const blackListErrorMsgEndpoints = ['/users/chat-details/login']
        if (error.response) {
            if (error.response?.status === 406) {
                return error.response.data
            }
            if (error.response.status === 401 && error.response.data?.statusCode !== 401) {
                errorCount++
                removeUserAuthCookie()
                if (errorCount === 1 && error.response.data.message !== 'Unauthorized') {
                    showErrorMessage(error.response.data.message)
                }
                return Promise.reject(error)
            }
            if (!blackListErrorMsgEndpoints.includes(error.response.config.url)) {
                if (!isEmpty(error.response.data.message)) {
                    showErrorMessage(error.response.data.message)
                }
                if (!isEmpty(error.response.data.error)) {
                    showErrorMessage(error.response.data.error)
                }
            }
        } else if (error.request) {
            // console.log(error.request)
        } else {
            // console.log('Error', error.message)
        }
        // console.log(error.config)
        return Promise.reject(error)
    }
)

//TODO some times do better
function showErrorMessage(message) {
    switch (message) {
        case 'Invalid input':
            notification.warning({
                message:
                    'You are either not registered in this event or using a different email. ' +
                    'Please contact the event organizer.'
            })
            break
        default:
            notification.warning({
                message
            })
            break
    }
}

export const getParams = payload => {
    const query: any = payload.query || undefined
    const pagination = payload.pagination || undefined
    const necessaryProjectionArray = payload.necessaryProjectionArray || undefined
    const needPopulate = payload.needPopulate || undefined
    const search = payload.search || undefined
    const populates = payload.populates || undefined
    const addPresignedURL = payload.addPresignedURL || undefined
    const hasTotal = payload.hasTotal || false
    const skip = payload.skip || undefined
    const sort = payload.sort || undefined
    const limit = payload.limit || undefined
    const params = {}

    if (query) Object.assign(params, { query })
    if (pagination) Object.assign(params, { ...pagination })
    if (necessaryProjectionArray?.length) Object.assign(params, { necessaryProjectionArray })
    if (addPresignedURL) Object.assign(params, { addPresignedURL })
    if (needPopulate) Object.assign(params, { needPopulate })
    if (search) Object.assign(params, { search })
    if (populates?.length) Object.assign(params, { populates })
    if (hasTotal) Object.assign(params, { hasTotal })
    if (skip) Object.assign(params, { skip })
    if (sort) Object.assign(params, { sort })
    if (limit) Object.assign(params, { limit })
    if (payload.fields) {
        Object.assign(params, { fields: payload.fields })
    }
    return params
}
export default request
